import { Button, Form, Input, message, Modal, Select, Spin } from 'antd';
import * as React from 'react';
import withStyles from 'react-jss';
import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { disableLoadTracking, enableLoadTracking, fetchTrackingData } from 'src/actions/shipmentExecutionActions';
import { useGenericState } from 'src/Library/UseGenericState';
import { FormComponentProps } from 'antd/lib/form';
import { StylesProps } from 'src/Library/Types';
import { ExecutionDetails } from '../SEDetails/shipment-details.types';
import { useState } from 'react';
import { interactive } from 'src/design-system/mixins';

const FormItem = Form.Item;

const styles = theme => ({
  hintHeader: {
    fontSize: theme.fontSize.caption,
    fontWeight: theme.fontWeight.semibold,
    color: '#262626',
    textAlign: 'left',
    paddingTop: '6px',
  },
  required: {
    color: '#EB2727',
  },
  form: {
    '& .ant-form-item': {
      width: '100% !important',
    },
    ...interactive.antFormRequiredHide,
    '& .ant-form-item-label': {
      lineHeight: '26px',
    },
    '& .ant-form-explain': {
      fontSize: '12px',
      left: '12px',
      position: 'absolute',
    },
  },
});

type IProps = ReduxProps & FormComponentProps & StylesProps<ReturnType<typeof styles>> & {
  data: ExecutionDetails;
  isVisible: boolean;
  onClose: () => void;
  updateCardData: () => void;
  referenceNumber: string;
  linkBlNumberToContainers: (linkedBlNumber: string) => void;
};

const SELinkBlNumber = (props: IProps) => {
  const {
    isVisible,
    classes,
    form,
    referenceNumber,
    onClose
  } = props;

  const [linkedBlNumber, setLinkedBlNumber] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const { getFieldDecorator, getFieldValue, getFieldsError, setFieldsValue } = form;


  async function submitLinkedBl() {
    setIsLoading(val => val = true);
    await props.linkBlNumberToContainers(linkedBlNumber)
    setIsLoading(val => val = false);
    props.onClose();
    await fetchTrackingData(referenceNumber);
  }

  

  const renderLinkedBlNumber = () => {
    return (
      <Form layout="inline" className={classes.form} style={{textAlign: 'center'}}>
          <FormItem colon={false}
            label={<div className={classes.hintHeader}>Linked BL Number <span
              className={classes.required}>*</span></div>}>
            {getFieldDecorator('linkedBlNumber', {
              initialValue: [],
              rules: [{ required: true, message: 'Linked BL Number is required' },
              {
                validator: (rule, value, callback) => {
                  value?.forEach((item) => {
                    if (item.length && item.match(/[^a-zA-Z0-9]/)) {
                      return callback(' Should be alphanumeric');
                    }
                    if (item.length > 25) {
                      return callback('Max length of 25 exceeded');
                    }
                  });
                  return callback();
                },
              }],
            })(
              <Input
              style={{
                overflow: 'hidden',
                marginLeft: '10px', 
                width: '170px'
              }}
              placeholder={'Linked BL Number'}
              onChange={(val) => {
                setLinkedBlNumber(val.target.value);
              }}
            />
            )}
          </FormItem>
      </Form>
    );
  };

  return (
    <>
      <Modal title={'Add Linked BL Number'}
        centered
        visible={isVisible} width={400} okText="Submit"
        onCancel={() => {props.onClose()}}
        destroyOnClose
        footer={[
          <Button key="back" onClick={onClose}>Cancel</Button>,
          <Button
            loading={isLoading}
            key="confirm"
            type="primary"
            disabled={isLoading}
            onClick={() => {
              submitLinkedBl()
            }}
          >Submit</Button>,
        ]}
        zIndex={1060}
        confirmLoading={false}
      >
        <div>
          {renderLinkedBlNumber()}
        </div>
      </Modal>
    </>
  );
}

const mapDispatchToProps = (dispatch) => (bindActionCreators({
  fetchTrackingData,
  enableLoadTracking,
  disableLoadTracking,
}, dispatch));

const mapStateToProps = ({ masterData }) => ({
  airlineList: masterData.globalAirLines,
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

const SEAddLinkedBlStyled = withStyles(styles)(Form.create()(SELinkBlNumber));
export default withRouter(connector(SEAddLinkedBlStyled));
